export const message = {
  saveDraftBPRelationshipMessage: 'Business Process Relationship successfully saved',
  publishBPRelationshipMessage: 'Business Process Relationship successfully published',
};